import { Activity } from "lucide-react";

export const IhsgChart = () => (
  <div
    data-testid="ihsg-chart"
    className="overflow-hidden rounded-lg border border-white/10 bg-black/50 backdrop-blur-xl"
  >
    <div className="flex items-center justify-between border-b border-white/10 px-3.5 py-2.5">
      <div className="flex items-center gap-2">
        <Activity size={13} className="text-[#00d09c]" />
        <p className="text-xs uppercase tracking-[0.18em] text-[#8f9bb3]">IHSG · Composite</p>
      </div>
      <span className="font-mono-num text-[10px] uppercase tracking-[0.14em] text-[#4d586f]">
        Harian
      </span>
    </div>
    <iframe
      data-testid="ihsg-chart-iframe"
      title="Grafik IHSG TradingView"
      src="https://s.tradingview.com/widgetembed/?symbol=IDX%3ACOMPOSITE&interval=D&theme=dark&style=1&locale=id&timezone=Asia%2FJakarta&hide_side_toolbar=0&allow_symbol_change=0&withdateranges=1&save_image=0&backgroundColor=%23080B11&gridColor=rgba(30%2C37%2C54%2C0.4)&hideideas=1"
      className="h-[260px] w-full border-0 sm:h-[300px]"
      allowFullScreen
      loading="lazy"
    />
  </div>
);
